// biome-ignore-all lint/suspicious/noArrayIndexKey: TODO - address later
import { HelpCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import type { FunctionSignature } from "@/lib/formula-validation-service";
import { cn } from "@/lib/utils";

interface FormulaSyntaxHintProps {
  signature: FunctionSignature;
  currentParameterIndex?: number;
  className?: string;
}

export function FormulaSyntaxHint({
  signature,
  currentParameterIndex = 0,
  className,
}: FormulaSyntaxHintProps) {
  return (
    <Card className={cn("p-3 bg-accent/30 border-accent", className)}>
      <div className="flex items-center gap-2">
        <HelpCircle className="h-4 w-4 text-muted-foreground flex-shrink-0" />

        <div className="flex items-center gap-1 flex-wrap">
          <span className="font-mono font-semibold text-sm">
            {signature.name}
          </span>
          <span className="text-muted-foreground">(</span>

          {signature.parameters.map((param, index) => (
            <span key={index} className="flex items-center">
              <Badge
                variant={
                  index === currentParameterIndex ? "default" : "secondary"
                }
                className={cn(
                  "text-xs font-mono px-2 py-0.5",
                  index === currentParameterIndex
                    ? "bg-primary text-primary-foreground"
                    : "bg-muted text-muted-foreground",
                )}
              >
                {param.name}
              </Badge>
              {index < signature.parameters.length - 1 && (
                <span className="text-muted-foreground mx-1">,</span>
              )}
            </span>
          ))}

          <span className="text-muted-foreground">)</span>
        </div>
      </div>

      {signature.description && (
        <div className="mt-2 text-xs text-muted-foreground">
          {signature.description}
        </div>
      )}

      {signature.parameters[currentParameterIndex] && (
        <div className="mt-2 text-xs text-primary">
          <strong>Current parameter:</strong>{" "}
          {signature.parameters[currentParameterIndex].name}
        </div>
      )}
    </Card>
  );
}
